import { Directive, forwardRef, Input, Type } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, NgModel, ValidationErrors, Validator } from '@angular/forms';

/**
 * tdWbSameEmailValidator
 * Raises error defined at tdWbRaiseErrorKey when the values of 2 form controls are EQUAL
 */
@Directive({
  selector: '[tdWbSameEmailValidator]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: forwardRef((): Type<SameEmailValidatorDirective> => SameEmailValidatorDirective),
    multi: true
  }]

})
export class SameEmailValidatorDirective implements Validator {
  @Input() tdWbSameEmailValidator: NgModel;

  validate(thisControl: AbstractControl): ValidationErrors | null {
    const areDifferent = thisControl.value !== this.tdWbSameEmailValidator.model;
    return areDifferent ? { emailCompare: areDifferent } : null;
  }
}
